import React from "react";
import { SERVICE_CART_PNG } from "../../constants/app.constants";

export function Logo(props) {
  return (
    <img src={SERVICE_CART_PNG} alt="Service Cart logo" />
  )
}